import axios from "axios";
import api from "../../../utils/api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../../utils/axiosConfig";

export const fetchReportData = createAsyncThunk(
  "documentList/fetchReportData",
  async (data, { rejectWithValue }) => {
    try {
      const { data: reportData }: any = await axiosInstance.get(
        `${api.baseURL}document/get-pending-group-by-supervisor`
      );

      return reportData;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
